export const ADD_TODO = "ADD_TODO";
export const TOGGLE_TODO = "TOGGLE_TODO";
export const SET_FILTER = "SET_FILTER";

export const ADD_AVAILABILITY = "ADD_AVAILABILITY";
export const REMOVE_AVAILABILITY = "REMOVE_AVAILABILITY";
export const CLEAR_AVAILABILITIES = "CLEAR_AVAILABILITIES";
